import { KendamaMapPoint } from '../types';

// Keep the data source separate so future forum posts can append or replace
// these points without touching the map rendering logic.
export const kendamaMapPoints: KendamaMapPoint[] = [
  {
    id: 'point-beijing-chaoyang',
    name: '北京朝阳公园剑玉练习点',
    lng: 116.478419,
    lat: 39.93349,
    description: '适合作为北京地区线下练习和新手交流集合点。',
    group: 'practice',
    updatedAt: 1749859200000,
  },
  {
    id: 'point-shanghai-xuhui',
    name: '上海徐汇滨江剑玉交流点',
    lng: 121.45468,
    lat: 31.185312,
    description: '适合公开活动、周末交流和视频拍摄。',
    group: 'club',
    updatedAt: 1749859200000,
  },
  {
    id: 'point-guangzhou-tianhe',
    name: '广州天河体育中心剑玉聚点',
    lng: 113.330761,
    lat: 23.13531,
    description: '广州核心城区常用练习点，交通方便。',
    group: 'practice',
    updatedAt: 1749859200000,
  },
  {
    id: 'point-chengdu-dongjiao',
    name: '成都东郊记忆剑玉活动点',
    lng: 104.122322,
    lat: 30.667044,
    description: '适合比赛活动、聚会与论坛打卡点联动。',
    group: 'brand',
    updatedAt: 1749859200000,
  },
];
